import React from 'react';
import {
    Box,
    Typography,
    Paper,
    Chip
} from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

const StudentTalentProfile = () => {
    return (
        <Box sx={{ p: 3 }}>
            <Paper sx={{ p: 4, borderRadius: 2, textAlign: 'center' }}>
                <EmojiEventsIcon sx={{ fontSize: 80, color: '#ff9800', mb: 2 }} />
                <Typography variant="h4" sx={{ fontWeight: 700, mb: 2, color: '#1a237e' }}>
                    Student Talent Profile
                </Typography>
                <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
                    Comprehensive student talent assessment and tracking system
                </Typography>
                <Chip label="Coming Soon" color="primary" />
            </Paper>
        </Box>
    );
};

export default StudentTalentProfile;

